import DefaultImage from "@assets/images/DefaultImage.svg";
import { CloseIcon } from "@chakra-ui/icons";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { NewTabIcon } from "@root/assets/icons/NewTabIcon";
import { useTranslation } from "react-i18next";

const SearchSourcesData = ({
  onClose,
  sources,
}: {
  onClose?: () => void;
  sources: any;
}) => {
  const { t } = useTranslation("common");
  function handlePreviewClick(url: string) {
    window.open(url, "_blank", "noopener,noreferrer");
  }

  function renderSources() {
    return (
      <>
        {sources.map((source: any, index: any) => (
          <Flex
            key={index}
            border="1px solid"
            borderColor="#F2F2F2"
            borderRadius="16px"
            p="16px"
            flexDir="column"
            gap="10px"
          >
            <Flex justifyContent="space-between">
              <Text textColor="#6B7280">
                {source.url
                  ? (() => {
                      const host = new URL(source.url).hostname.replace(
                        /^www\./,
                        ""
                      );
                      return host.length > 50
                        ? `${host.slice(0, 50)}...`
                        : host;
                    })()
                  : ""}
              </Text>

              <Flex
                gap="8px"
                alignItems="center"
                cursor="pointer"
                onClick={() => handlePreviewClick(source.url)}
              >
                <NewTabIcon />
                <Text fontSize="16px" fontWeight="400" color="#059669">
                  {t("hannan.seeMore")}
                </Text>
              </Flex>
            </Flex>

            <Flex gap="10px" alignItems="self-start" marginBottom="5px">
              <Image
                borderRadius="8px"
                src={source.metadata.favicon || DefaultImage}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = DefaultImage;
                }}
                width="64px"
                height="64px"
                alt={source.title}
              />

              <Box>
                <Text
                  color="#111827"
                  fontWeight={600}
                  marginBottom="5px"
                  marginTop="2px"
                  fontSize="16px"
                >
                  {source.title}
                </Text>
                <Text fontSize="14px" color="#6B7280" fontWeight={400}>
                  {source.content}
                </Text>
              </Box>
            </Flex>
          </Flex>
        ))}
      </>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between">
        <Text fontWeight="600" fontSize="22px">
          {/* {t("Sources")} */}
        </Text>
        <CloseIcon onClick={onClose} cursor="pointer" />
      </Flex>
      <Flex mt={5} flexDirection="column" gap="15px">
        {renderSources()}
      </Flex>
    </Box>
  );
};

export default SearchSourcesData;
